<template>
    <v-navigation-drawer stateless value="true" dark>
        <v-list>
            <v-list-item :to="nav.url" v-for="nav of navigation" :key="Math.random()">
                <v-list-item-action>
                    <v-icon>{{ nav.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ nav.title }}</v-list-item-title>
            </v-list-item>
        </v-list>

        <v-spacer/>

        <template v-if="project && project.iiko_integration" v-slot:append>
            <div class="pa-2 text-center">
                <v-btn @click="iikoSync">Iiko sync</v-btn>
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
import Product from '../../api/product'

export default {
    name: 'navigationCatalog',
    data: () => ({
        project: null,
        navigation: [
            {
                title: 'Главная',
                icon: 'home',
                url: '/'
            },
            {
                title: 'Каталог',
                icon: 'subject',
                url: '/catalog/category'
            }
        ]
    }),

    methods: {
        async iikoSync () {
            let success = confirm('Синхронизировать продукты? После синхронизации страница будет перезагружена')
            if (success) {
                this.$emit('syncStarted', 1)
                try {
                    let { data } = await Product.syncIikoProducts()

                    this.$emit('syncComplete', 1)
                } catch (e) {
                    this.$emit('syncError', 1)
                    this.$store.commit('showSnackbar', {
                        text: 'Возникла ошибка с синхронизацией продуктов',
                        color: 'error'
                    })
                }
            }
        }
    },

    created () {
        let user = sessionStorage.getItem('user')
        if (user) {
            let userObject = JSON.parse(user)
            if (userObject) {
                this.project = userObject.data.project
            }
        }
    },
}
</script>
